/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Header } from '@mairistem/composants';
import { PanelButtonEdition } from '@mairistem/administres-utils';

import BlocChamps from './BlocChamps';
import type { SectionChamps } from './BlocChamps';

interface InformationsRegistreActeProps {
  acte?: any;
  /** Champs à afficher, produits par `FICHE_CONFIG[type].blocs.registreActe`. */
  sections: SectionChamps[];
  /** Modale d'édition ; son absence rend le bloc en lecture seule. */
  Modal?: React.ComponentType<any>;
  /** Props propres au type d'acte (référentiel du sous-type, types de registre). */
  propsModal?: Record<string, unknown>;
  service?: { update: (data: Record<string, any>) => Promise<any> };
  onSaved: (acte: any) => void;
}

const InformationsRegistreActe = (props: InformationsRegistreActeProps) => {
  const { acte, sections, Modal, propsModal, service, onSaved } = props;

  const [editing, setEditing] = React.useState(false);

  return (
    <div style={{ position: 'relative' }}>
      {Modal && <PanelButtonEdition onClick={() => setEditing(true)} />}
      {sections.map((section) => (
        <React.Fragment key={section.titre ?? 'registre-acte'}>
          {/*
            Sous-titre d'une section, quand elle en porte un — le mariage y range
            son officier d'état civil. Même habillage que les sous-titres du
            panneau des individus, pour que les deux se lisent pareil.
          */}
          {section.titre && (
            <Header
              as="h5"
              color="blue"
              style={{ marginTop: '1em', marginBottom: '0.5em' }}
            >
              {section.titre}
            </Header>
          )}
          <BlocChamps
            lignes={section.lignes}
            styleLigne={{ paddingRight: '2em' }}
          />
        </React.Fragment>
      ))}

      {Modal && (
        <Modal
          {...propsModal}
          open={editing}
          acte={acte}
          service={service}
          onClose={() => setEditing(false)}
          onSaved={onSaved}
        />
      )}
    </div>
  );
};

export default InformationsRegistreActe;
